import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { LottieModule } from '@shared-ui-lib/lottie/lottie.module'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        LandingPageSectionContainerModule,
        LottieModule,
        MatIconModule,
        TranslationModule,
    ],
    selector: 'app-landing-page-fleet-management',
    templateUrl: './landing-page-fleet-management.component.html',
    styleUrls: ['./landing-page-fleet-management.component.scss'],
})
export class LandingPageFleetManagementComponent {
    constructor() {}
}
